import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/commons/generic.service';
import { PcdPosRecadDto } from 'app/components/pos-recadastramento/aba7-posrecad/pcdPosRecad.dto';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PosCampanhaServiceAba7 extends GenericService {

  private baseUrl = environment.url + 'api/v1';

  constructor(http: HttpClient) {
    super(http);
   }

  getObterPCD(param: number): Observable<PcdPosRecadDto> {
    return this.getMethod<PcdPosRecadDto>(`api/v1/admin/validacao-recadastramento/deficiencia`, { validacaoRecadId: param });
  }

  postDadosPCD(body): Observable<PcdPosRecadDto> {
    return this.http.post<any>(this.baseUrl + `/admin/validacao-recadastramento/deficiencia`, body);
  }

}
